<template>
  <div>
    <div v-if="form">
      <div>
        <p><b>status</b></p>
        <select v-model="form.data.position.fields.status.value" dir="ltr">
          <option value="editing">editing</option>
          <option value="active">active</option>
          <option value="standby">standby</option>
          <option value="blocked">blocked</option>
          <option value="expired">expired</option>
          <option value="fullfiled">fullfiled</option>
          <option value="deleted">deleted</option>
          <option value="test">test</option>
        </select>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import PositionsHelper from '@/custom/classes/positions_helper.js'
export default {
  name: 'position-status-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      positions_helper: new PositionsHelper(),
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getPosition({ id: this.payload.position_data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        position: {
          fields: {
            status: {
              value: form_data.status,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/positions/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then(() => {
        this.is_loading = false
        this.generateOffers()
        this.positions_helper.logToServer({
          old_status: this.payload.position_data.status,
          new_status: this.form.data.position.fields.status.value,
          resource_id: this.payload.position_data.id,
          position_title: this.payload.position_data.title,
          company_id: this.payload.position_data.company.resource_id
        })
        this.remove(this.payload)
        this.$utils.emit('show_toast', { text: 'success' })
      })
    },
    generateOffers () {
      this.$network_utils.sendPositionUpdateEvent({
        company_id: this.payload.position_data.company.resource_id,
        position_id: this.payload.position_data.id,
        status: this.form.data.position.fields.status.value
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
